import { isNumber } from "@ciaopeople/cp-shatsu/TypeChecking";
import { getCachedCookie } from "../../../../lib/utils/CookieReader.js";
import { AdUnit } from "../../AdUnit.js";
import { AdCallParams } from "../../AdCallParams.js";
import { HasAdCallParamsFilter } from "../ComposableResolver.js";
import { CP_SexValue } from "../CustomParams.js";
import { VideoInfoRawData } from "../../../../model/video/VideoInfo.js";


export type AdCookiesConfig = {

    age_and_sex: string,
    profiling_disable: string,
    apat_cookie: string,
    num_pageviews: string

};

 
export const DefaultAdCookiesConfig: AdCookiesConfig = {
    age_and_sex: "fp_ad",
    profiling_disable: "prof_optout",
    apat_cookie: "apat",
    num_pageviews: "fp_npv"
}

export type UD_AgeAndSex = {age?: number, sex?: CP_SexValue}

export class UserAdsData implements HasAdCallParamsFilter{


    constructor(private window: Window, private config: AdCookiesConfig = DefaultAdCookiesConfig) {

    }

    getUserAgeAndSex():  UD_AgeAndSex{

        const aas = getCachedCookie(this.window,this.config.age_and_sex);
        let age: number = -1;
        let sex: CP_SexValue = CP_SexValue.UNKNOWN;
        if(aas && aas.trim().length > 0) {
            const split = aas.split(".");
            const maybeAge = parseInt(split[0]);
            if(isNumber(maybeAge) && !isNaN(maybeAge) && maybeAge > 0) age = maybeAge;
            if(split[1]) {
                switch(split[1]) {
                    case "1":
                        sex = CP_SexValue.MALE;
                        break;
                    case "2":
                        sex = CP_SexValue.FEMALE;
                        break;
                    default:
                        break;
                }
            }
        }
        const retval: UD_AgeAndSex = {};
        if(age > 0) retval.age = age;
        else if (sex && sex != CP_SexValue.UNKNOWN) retval.sex = sex;
        return retval;

    }


    getApat(): string {
        return getCachedCookie(this.window,this.config.apat_cookie);
    }


    isOptOut(): boolean {
        
        const cookie = getCachedCookie(this.window,this.config.profiling_disable);
        return cookie && cookie == "1";
    }

    getNumberPageviews(): number {
        const valString = getCachedCookie(this.window,this.config.num_pageviews);

        if(valString) {
            const val = parseInt(valString);
            if(val && (isNumber(val)) && !isNaN(val) && val >= 0) return val;
        }
        return -1;
    }


    filterAdCall(unit: AdUnit, info: VideoInfoRawData, params: AdCallParams): AdCallParams {
        const useParams: AdCallParams = params?params:{};
        useParams.custom_params = useParams.custom_params?useParams.custom_params:{};
        
        if(!this.isOptOut()) {
            const aas = this.getUserAgeAndSex();
            if(aas.age) useParams.custom_params.age = aas.age;
            if(aas.sex) useParams.custom_params.sex = aas.sex;
        }
        const pv = this.getNumberPageviews();
        if(pv >= 0) useParams.custom_params.num_session_page_views = pv;


        return useParams;
    }


}
